import Marionette from "backbone.marionette";
import Bootstrap from "bootstrap-loader";
import BTable from "bootstrap-table";

// Import bootstrap-table styles manually
import BTableCSS from "../node_modules/bootstrap-table/dist/bootstrap-table.min.css";

import Notifier from "views/notifications.js";

import MainView from "views/mainView.js";
import LoginView from "views/login/loginView.js";

import TranslationsCollection from "collections/translationsCollection.js";

/////actividades de usuario
import UserActivityModel from "models/useractivityModel.js";

import S from "session/session.js";
import T from "session/token.js";

S.mApp = new Marionette.Application({
    onStart: function() {
        Notifier(); //Register events for notifications
        var viewport = document.querySelector('meta[name=viewport]');
        var viewportContent = 'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=0';

        if (viewport === null) {
            var head = document.getElementsByTagName('head')[0];
            viewport = document.createElement('meta');
            viewport.setAttribute('name', 'viewport');
            head.appendChild(viewport);
        }

        viewport.setAttribute('content', viewportContent);
    },
    regions: {
        mainRegion: "#mainApp"
    }
});

S.mApp.on("access:pass", function() {
    S.mApp.mainRegion.show(new MainView());
    $("body").removeClass().addClass("hold-transition skin-black fixed layout-top-nav");
    $(".main-sidebar").hide();
});

// Before start application, check ouath token
////////////////////////////////////////
S.mApp.on("before:start", function() {
    if (!T.getToken()) {
        //If no token pass, stop application run and show login
        S.mApp.off('start');
        var translations = new TranslationsCollection();
        //get translations for login pages
        translations.fetch({
            data: {
                page: "login",
                lang: navigator.language || navigator.userLanguage
            },
            success: function(collection) {
                this.mainRegion.show(new LoginView({
                    collection: collection
                }));

            }.bind(this)
        });
    }
});

S.mApp.start();

//// =============
/////CADA 5 MINUTOS 
//// =============
var dateIni = new Date();
var numIni = dateIni.getTime();
var checkGeneratingPDF = false;

setInterval(function() {

    if (S.token) {

        var nowDate = new Date();
        var numNow = nowDate.getTime();

        var diff = numNow - numIni;
        var min_che_v = diff / (1000 * 60);

        var str = window.location.href;
        var n = str.indexOf("report");
        if (n >= 0) {

        } else {

            ////MAYOR DE 30 MINUTOS
            if (min_che_v >= 30) {
                ///HA ESTADO  MAS DE 10 MINUTOS INACTIVO ..                
                T.deleteToken();
                window.top.location = "";

            }
        }

        /////guardar en base de datos mi conexion actual. 
        this.modelAct = new UserActivityModel({});

        this.modelAct.save({
            instanceId: S.instanceId
        }, {
            beforeSend: T.useToken
        });

    }

    /////}, 60000);
}, 300000);



$(document).keypress(function(e) {

    dateIni = new Date();
    numIni = dateIni.getTime();
});



$("body").mouseover(function() {

    dateIni = new Date();
    numIni = dateIni.getTime();
});


//////////////////
// WEBPACK FOOTER
// ./app/index.js
// module id = 160
// module chunks = 0